export const RES_ACC_OPTIONAL_FIELDS = [
	{
		subtitle: 'Customer Information',
		fields: [
			{value: 'client_no', label: 'ClientID'},
			{value: 'customer_addr1', label: 'Customeraddressline1'},
			{value: 'customer_addr2', label: 'Customeraddressline2'},
			{value: 'customer_addr3', label: 'Customeraddressline3'},
			{value: 'customer_postal_code', label: 'Customerpostal/zipcode'},
			{value: 'customer_postal_city', label: 'Customerpostalcity'},
			{value: 'customer_country_text', label: 'Customercountryastext'},
			{value: 'customer_country_code', label: 'Customercountrycode'},
			{value: 'customer_org_no', label: 'Customerorganization/VATnumber'},
			{value: 'customer_email_doc', label: 'Customeremailfordocumentdistribution'},
			{value: 'customer_email_extra', label: 'Customerextraemailaddress'},
			{value: 'customer_phone_no_customer', label: 'Customerphonenumber'},
			{value: 'customer_phone_no_contact', label: 'Customercontactphonenumber'},
			{value: 'customer_bank_account_no', label: 'Customerbankaccountnumber'},
		]
	},
	{
		subtitle: 'Payment & Document Information',
		fields: [
			{value: 'payment_cid', label: 'KID/CIDpaymentidentificationnumber'},
			{value: 'voucher_type_code', label: 'Vouchertypecode'},
			{value: 'doc_type_code', label: 'Documenttypecode'},
			{value: 'doc_distrib_code', label: 'Documentdistributiontype'},
			{value: 'doc_distrib_text', label: 'Documentdistributiondescription'},
			{value: 'orig_doc_distrib_code', label: 'Originaldocumentdistributiontype'},
			{value: 'avtalegiro', label: 'Avtalegiropaymentflag'},
			{value: 'einvoice_code', label: 'Electronicinvoicedistributioncode'},
			{value: 'distrib_count', label: 'Countofdistributionattempts'},
			{value: 'document_status_code', label: 'Documentproductionstatus'},
			{value: 'distrib_time', label: 'Documentdistributiontime'},
			{value: 'doc_copy_distrib_code', label: 'Documentcopydistributiontype'},
			{value: 'doc_copy_distrib_time', label: 'Documentcopydistributiontime'},
		]
	},
	{
		subtitle: 'Transaction Details',
		fields: [
			{value: 'transaction_text', label: 'ARtransactiondescription'},
			{value: 'gl_year', label: 'GLbookkeepingyear'},
			{value: 'gl_period', label: 'GLbookkeepingperiod'},
			{value: 'voucher_date', label: 'Voucherpostingdate'},
			{value: 'orig_due_date', label: 'Originalduedate'},
			{value: 'latest_reminder_date', label: 'Latestreminderissuedate'},
			{value: 'latest_reminder_due_date', label: 'Latestreminderduedate'},
			{value: 'currency_sum_reminder_fee', label: 'Accumulatedreminderfee'},
			{value: 'interest_date', label: 'Interestcalculationbasedate'},
			{value: 'currency_sum_interest', label: 'Calculatedinterestamount'},
			{value: 'settle_date', label: 'Itemsettlementdate'},
			{value: 'settle_status_code', label: 'Settlementstatus'},
		]
	},
	{
		subtitle: 'Currency & Amounts',
		fields: [
			{value: 'currency_code', label: 'Itemcurrencycode'},
			{value: 'currency_amount', label: 'Itemamountinitem\'scurrency'},
			{value: 'currency_balance_customer', label: 'Customerbalanceincurrency(notinuse)'},
			{value: 'currency_balance_due_item', label: 'Itemduebalanceincurrency'},
			{value: 'currency_balance_due_customer', label: 'Customerduebalanceincurrency(notinuse)'},
			{value: 'gl_balance_item', label: 'ItembalanceinGLcurrency'},
			{value: 'gl_balance_customer', label: 'CustomerbalanceinGLcurrency'},
			{value: 'gl_balance_due_item', label: 'ItemduebalanceinGLcurrency'},
			{value: 'gl_balance_due_customer', label: 'CustomerduebalanceinGLcurrency'},
		]
	},
	{
		subtitle: 'Reminder & Collection',
		fields: [
			{value: 'reminder_step', label: 'Reminderstep/degree'},
			{value: 'stop_reminder_item', label: 'Reminderstopdateforitem'},
			{value: 'stop_reminder_customer', label: 'Reminderstopdateforcustomer'},
			{value: 'stop_reminder_client', label: 'Reminderstopdateforclient'},
			{value: 'stop_debt_coll_item', label: 'Debtcollectionstopdateforitem'},
			{value: 'stop_debt_coll_customer', label: 'Debtcollectionstopdateforcustomer'},
			{value: 'stop_debt_coll_client', label: 'Debtcollectionstopdateforclient'},
			{value: 'stop_calc_interest_item', label: 'Interestcalculationstopdateforitem'},
			{value: 'stop_calc_interest_customer', label: 'Interestcalculationstopdateforcustomer'},
			{value: 'stop_calc_interest_client', label: 'Interestcalculationstopdateforclient'},
			{value: 'transf_to_debt_coll_date', label: 'Transfertodebtcollectiondate'},
			{value: 'transf_to_debt_coll_gl_amount', label: 'Amounttransferredtodebtcollection(GL'},
			{value: 'transf_to_debt_coll_curr_amount', label: 'Amounttransferredtodebtcollection(currency'},
			{value: 'debt_coll_system', label: 'Debtcollectionsystemcode'},
			{value: 'debt_coll_service_code', label: 'Debtcollectionservicecode(notinuse'},
			{value: 'debt_coll_service_text', label: 'Debtcollectionservicetext(notinuse'},
			{value: 'debt_coll_service_date', label: 'Debtcollectionservicedate(notinuse'},
			{value: 'debt_coll_status_code', label: 'Debtcollectionstatuscode'},
			{value: 'debt_coll_status_text', label: 'Debtcollectionstatustext'},
			{value: 'debt_coll_status_date', label: 'Debtcollectionstatusdate(notinuse'},
			{value: 'debt_coll_close_code', label: 'Debtcollectionclosecode'},
			{value: 'debt_coll_close_text', label: 'Debtcollectionclosetext'},
			{value: 'debt_coll_close_date', label: 'Debtcollectionclosedate'},
		]
	},
	{
		subtitle: 'Postal & Returns',
		fields: [
			{value: 'postal_return_code_doc', label: 'Postalreturnstatusfordocument'},
			{value: 'postal_return_code_customer', label: 'Postalreturnstatusforcustomer'},
			{value: 'postal_return_date_doc', label: 'Latestpostalreturndatefordocument'},
			{value: 'postal_return_date_customer', label: 'Latestpostalreturndateforcustomer'},
		]
	},
	{
		subtitle: 'Internal References',
		fields: [
			{value: 'a3rpost_obj', label: 'InvoiciainternalARitemreferenceID'},
			{value: 'f1fakth_obj', label: 'InvoiciainternaldocumentreferenceID'},
			{value: 'internal_acct_no', label: 'InvoiciainternalARaccountnumber'},
			{value: 'internal_ref_no', label: 'InvoiciainternalreferenceID'},
			{value: 'internal_seq_no', label: 'InvoiciainternalsequenceID'},
			{value: 'internal_case_no', label: 'Invoiciainternalcasenumber'},
			{value: 'internal_voucher_no', label: 'Invoiciainternalvouchernumber'},
			{value: 'internal_gl_lot', label: 'InvoiciainternalGLlotID'},
			{value: 'internal_doc_id', label: 'InvoiciainternaldocumentID'},
			{value: 'internal_doc_bundle_id', label: 'InvoiciainternaldocumentbundleID'},
		]
	},
	{
		subtitle: 'External & Status',
		fields: [
			{value: 'external1_id', label: 'ItemexternaluniqueID'},
			{value: 'external_status_code', label: 'Externalstatuscode'},
			{value: 'external_status_text', label: 'PaymentURLforonlinepayment'},
			{value: 'external_time', label: 'Externaltime'},
			{value: 'external1_system', label: 'Externalsystem'},
			{value: 'confirmed_sent_time', label: 'Confirmedsenttime'},
			{value: 'resent_time', label: 'Resenttime'},
		]
	},
	{
		subtitle: 'Notes & Metadata',
		fields: [
			{value: 'ledger_note_count', label: 'Countofinternalledgernotes'},
			{value: 'ledger_notes', label: 'Ledgernotes(notinuse'},
			{value: 'created_time', label: 'Itemcreationtimestamp'},
			{value: 'customer_reg_status_code', label: 'Customerregistrationstatus'},
			{value: 'customer_reg_status_date', label: 'Customerregistrationstatustimestamp'},
			{value: 'source_item_internal_ref_no', label: 'Sourceiteminternalreference'},
			{value: 'source_item_invoice_no', label: 'Sourceiteminvoicenumber'},
			{value: 'doc_distrib_message', label: 'SMStextifdistributedviaSMS'},
		]
	},
	{
		subtitle: 'Loss & Revenue',
		fields: [
			{value: 'currency_loss_amount_item', label: 'Loss/revenueamountforitem(currency)'},
			{value: 'gl_loss_amount_item', label: 'Loss/revenueamountforitem(GL)'},
			{value: 'gl_loss_amount_customer', label: 'Loss/revenueamountforcustomer(GL)'},
		]
	}
];